import { NSMenuActionProps } from "namirasoft-site-react";
import { JobArrangerBrowsers } from "./JobArrangerBrowsers";

export class JobArrangerMenus
{
    static download(): NSMenuActionProps
    {
        const extensionLink = JobArrangerBrowsers.getExtensionLink();

        return {
            id: "1",
            menu_item: "Download Extension",
            isActive: () => extensionLink !== null,
            onClick: {
                showLoading: false,
                action: () => extensionLink && window.open(extensionLink, "_blank"),
            }
        }
    }
}